import React, { useState } from "react";
import { Box, IconButton, MenuItem, Popover, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import LanguageIcon from "@mui/icons-material/Language";
import { flagUrl } from "../config";

// ----------------------------------------------------------------------

const LANGS = [
  {
    value: "en",
    label: "english",
    icon: flagUrl("US.png"),
  },
  {
    value: "ps",
    label: "pashto",
    icon: flagUrl("Afg.png"),
  },
  {
    value: "dr",
    label: "dari",
    icon: flagUrl("Afg.png"),
  },
];

// ----------------------------------------------------------------------

const LanguageSelector = () => {
  const [open, setOpen] = useState(null);
  const { t, i18n } = useTranslation();

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const setLanguage = (value) => {
    setOpen(null);
    i18n.changeLanguage(value);
    const direction = value === "en" ? "ltr" : "rtl";
    localStorage.setItem("direction", direction);
    document.body.setAttribute("dir", direction);
  };

  const close = () => {
    setOpen(null);
  };

  return (
    <Box>
      <IconButton
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
        }}
      >
        <LanguageIcon sx={{ color: "white" }} fontSize="small" />
      </IconButton>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={close}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1,
            ml: 0.75,
            width: 180,
          },
        }}
      >
        {LANGS.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => setLanguage(option.value)}
            sx={{ typography: "body2", py: 1 }}
          >
            <Box
              component="img"
              alt={option.label}
              src={option.icon}
              sx={{ width: 28, mr: 2 }}
            />
            <Typography>{t(`language.${option.label}`)}</Typography>
          </MenuItem>
        ))}
      </Popover>
    </Box>
  );
};

export default LanguageSelector;
